import { guidGenerator } from "shared/helpers";

export const formatForSave = (varietyData) => {
    return Object.keys(varietyData).map((v) => {
        return {
            ...varietyData[v],
        };
    });
};

export const formatForUse = (data) => {
    return data.reduce((obj, variety) => {
        var varietyId = variety.code || guidGenerator().toString();
        obj[varietyId] = {
            ...variety,
            code: varietyId,
        };

        return obj;
    }, {});
};

export const newVariety = (name) => {
    var varietyId = guidGenerator().toString();

    return {
        [varietyId]: {
            variety: name || "",
            code: varietyId,
            linkCode: "",
            childLinks: [],
            packAttributes: {},
            sharedValues: [],
            isVarietyUpdated: false,
            updatedUUIDs: null,
        },
    };
};

export const varietyListMap = (data) => {
    return Object.keys(data).map((key) => {
        return {
            value: key,
            text: data[key].variety,
            linkCode: data[key].linkCode,
        };
    });
};

export const varietyWithLinkList = (data) => {
    return Object.keys(data).reduce((arr, key) => {
        if (data[key].linkCode) {
            arr.push(key);
        }

        return arr;
    }, []);
};
